module.exports = __webpack_public_path__ + "static/img/tokyolegacyhalfmarathon.7929728.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tmf/tokyolegacyhalfmarathon.svg
// module id = 2jqp
// module chunks = 1